import { render, staticRenderFns } from "./Error404.vue?vue&type=template&id=e720c4e8&scoped=true&"
import script from "./Error404.vue?vue&type=script&lang=js&"
export * from "./Error404.vue?vue&type=script&lang=js&"
import style0 from "./Error404.vue?vue&type=style&index=0&id=e720c4e8&prod&lang=scss&"
import style1 from "./Error404.vue?vue&type=style&index=1&id=e720c4e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e720c4e8",
  null
  
)

export default component.exports